export const INTERRUPTION_MODES = [
  'allow',
  'disable_during_tool',
  'disable_during_tool_and_turn',
] as const;

export type InterruptionMode = (typeof INTERRUPTION_MODES)[number];

export const PRE_TOOL_SPEECH_OPTIONS = ['auto', 'force', 'off'] as const;

export type PreToolSpeech = (typeof PRE_TOOL_SPEECH_OPTIONS)[number];

/** How a tool (an MCP tool or an action webhook) behaves on a voice call. */
export type ToolSettings = { interruption_mode: InterruptionMode; pre_tool_speech: PreToolSpeech };

export const DEFAULT_TOOL_SETTINGS: ToolSettings = {
  interruption_mode: 'disable_during_tool_and_turn',
  pre_tool_speech: 'auto',
};
